/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import CustomDashboardCard from '../../../../common/components/CustomDashboardCard/CustomDashboardCard';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import EventsBox from '../../components/EventsContentBox/EventsBox';

interface eventsListProps {
  events: any;
  isLoading?: boolean;
  i18n: any;
  trans: any;
}

const UpcomingEventsPresenter = ({
  events,
  isLoading,
  trans,
}: eventsListProps) => {
  return (
    <>
      <CustomDashboardCard cardSize={{ card_title: trans("What's New") }}>
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <EventsBox events={events} />
        )}
      </CustomDashboardCard>
    </>
  );
};

export default UpcomingEventsPresenter;
